import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Button from '../Button/Button'

import {
  StyledButtonsContainer,
  StyledLocationCapacities,
  StyledRichText,
  StyledTab,
  StyledTabContent,
  StyledTabs,
} from './LocationCapacities.styled'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import CapacitiesCollapse from '../CapacitiesCollapse/CapacitiesCollapse'
import UrlFactory from '../../utils/UrlFactory'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import useMediaQuery from "../../hooks/useMediaQuery";
import {deviceMax} from "../../theme/breakpoints";

const MARKETS = 'Markets'

const LocationCapacities = (props) => {
  const {content, markets} = props
  const isMobile = useMediaQuery(deviceMax.mobileL)
  const [activeTab, setActiveTab] = useState(0)
  const [collapses, setCollapses] = useState([])
  const [tabsContent, setTabsContent] = useState([])
  const [tabs, setTabs] = useState([])
  const [target, setTarget] = useState(null)

  useEffect(() => {
    isMobile && setActiveTab(!isMobile ? 0 : null)
  }, [isMobile])

  useEffect(() => {
    if (!tabs || !target) return
    window.scrollBy(0, target.parentNode.getBoundingClientRect().y)
  }, [tabs])

  useEffect(() => {
    setCollapses([])
    setTabs([])
    setTabsContent([])
    for (const [index, capacity] of content.entries()) {
      if (!capacity.tabTitle && !capacity.text) {
        return null
      }

      const buttons =
        capacity.type === MARKETS
          ? markets.map((market, index) => {
            return (
              <Button
                key={market + index}
                label={market}
                to={UrlFactory.getMarketUrl(market)}
                variant={ButtonVariantEnum.tertiary}
              />
            )
          })
          : capacity.buttons &&
          capacity.buttons.map((button, index) => {
            return (
              <Button
                key={index}
                label={button.label}
                href={button.url && button.url}
                to={button.to && button.to}
                variant={ButtonVariantEnum.tertiary}
              />
            )
          })

      setCollapses((prev) => [
        ...prev,
        <CapacitiesCollapse
          active={activeTab === index}
          buttons={buttons}
          key={capacity.id}
          setActive={(e) => handleActiveCollapse(e, index)}
          textHtml={capacity.textHtml}
          title={capacity.tabTitle}
        />,
      ])
      setTabs((prev) => [
        ...prev,
        <StyledTab
          active={activeTab === index}
          key={capacity.id}
          label={capacity.tabTitle}
          onClick={() => setActiveTab(index)}
          variant={ButtonVariantEnum.tertiary}
        />,
      ])
      setTabsContent((prev) => [
        ...prev,
        <StyledTabContent active={activeTab === index} key={capacity.id}>
          {capacity.textHtml && (
            <StyledRichText>
              <CKEditorContent html={capacity.textHtml.content}/>
            </StyledRichText>
          )}
          <StyledButtonsContainer>{buttons}</StyledButtonsContainer>
        </StyledTabContent>,
      ])
    }
  }, [isMobile, activeTab])

  const handleActiveCollapse = (event, index) => {
    if (index === activeTab) {
      setTarget(null)
      return setActiveTab(null)
    }
    setTarget(event.target)
    return setActiveTab(index)
  }

  return (
    <StyledLocationCapacities>
      {isMobile ? (
        <div>{collapses}</div>
      ) : (
        <>
          <StyledTabs>{tabs}</StyledTabs>
          {tabsContent}
        </>
      )}
    </StyledLocationCapacities>
  )
}

LocationCapacities.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  markets: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default LocationCapacities
